jQuery(document).ready(function ($) {

    isSmallMobile = {
        any: function () {
            return $(window).width() < 767;
        }
    };

    // Mobile Footer Menus
    if ($(window).width() <= 767) {
        // Changing widgettitle from span to button for accessibility
        $(".footerRow .linkWrapper__widgets li.widget .widgettitle").replaceWith(function () {
            return "<button class='widgettitle' role='heading' aria-level='3'>" + this.innerHTML + "</button>";
        });

        $('.footerRow .linkWrapper__widgets .widget').on('click', function () {
            $(this).toggleClass('active').siblings().removeClass('active');
            $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
        });
    }

    // Place Homepage only Javascript inside of IF statement
    if (document.body.classList.contains('home')) {
        // Triple Slider Row
        var triple_slider = new Swiper('.tripleSliderRow .swiper-container', {
			speed: 300,
			slidesPerGroup: 3,
			slidesPerView: 3,
			spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
			preloadImages: false,
			navigation: {
				nextEl: '.tripleSliderRow .swiper-button-next.model',
				prevEl: '.tripleSliderRow .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 2,
					slidesPerView: 2
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
		});

		//START - MODEL ROW
		models_slider = new Swiper('#model0', {
			speed: 300,
			slidesPerGroup: 5,
			slidesPerView: 5,
			spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
			preloadImages: false,
			autoplay: true,
			observer: true,
			observeParents: true,
			lazy: {
				enabled: true,
			},
			navigation: {
				nextEl: '#model0 .swiper-button-next.model',
				prevEl: '#model0 .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 3,
					slidesPerView: 3
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
		});

		$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {

			var paneTarget = $(e.target).attr('href');
			var thePane = $('.tab-pane' + paneTarget);
			var paneIndex = thePane.index();

			if(typeof(window['models_slider'+paneIndex]) == 'undefined'){

				window['models_slider'+paneIndex] = new Swiper('#model'+paneIndex, {
					initialSlide: 0,
					speed: 300,
					slidesPerGroup: 5,
					slidesPerView: 5,
					spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
					preloadImages: false,
					autoplay: true,
					observer: true,
					observeParents: true,
					lazy: {
						enabled: true,
					},
					navigation: {
						nextEl: '#model'+paneIndex+'.swiper-container .swiper-button-next.model',
						prevEl: '#model'+paneIndex+'.swiper-container .swiper-button-prev.model'
					},
					breakpoints: {
						1024: {
							slidesPerGroup: 3,
							slidesPerView: 3
						},
						767: {
							slidesPerGroup: 1,
							slidesPerView: 1
						},
					},
				});
			}
		});
		//END - MODEL ROW

		if ($(window).width() <= 1024) {
			jQuery('#small-selects #modelTab-contents li a').click(function() {
				var title = jQuery(this).data('title');
				jQuery('#modelTab .swap').html(title);
			});
		}
    }

});

